import HubPage from '../../components/HubPage';
export default function ProductivityHub() { return <HubPage hubKey="productivity" />; }
